import { Flex } from "@braze/beacon-core"
import { useState } from "react"
import styled from "styled-components"
import { NavButton } from "./NavButton";

export const NavTabs = () => {

    const [open, setOpen] = useState(false);


    return (

        <Main>

            <ButtonBox>
                <NavButton 
                    handleClick={()=>setOpen(false)}
                    icon='search' 
                    title='Campaign Analysis' 
                    description='Examine campaign metrics'
                    link_path="campaign-analysis"/>
                <NavButton 
                    handleClick={()=>setOpen(false)}
                    icon='gear' 
                    title='MarOps Tools' 
                    description='Settings and tools for MarOps use'
                    link_path="settings"/>
            </ButtonBox>
        </Main>


    )

}

const Main = styled(Flex)`
// padding: 2em 4em;
//   margin: 3em;
  background: #fff;
  border-radius: 1.5em;
  border: 1px solid rgba(0, 0, 0, 0.05);
  flex-direction: column;
  min-width: 100%;
//   padding: 2rem 2rem;
`

const ButtonBox = styled(Flex)`
    padding-right: 2rem;
    padding-left: 2rem;
    padding-bottom: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 3rem;
    background: #fff;
`